<template>
	<div class="mb-4 lg:px-10 space-y-2">
		<div
			v-for="item in items"
			:key="item.id"
			class="
				grid
				gap-2
				sm:gap-4
				items-center
				py-2
				grid-cols-[minmax(auto,_3.75rem)_1fr_0fr]
			"
		>
			<div class="w-[3.125rem] md:w-[3.75rem]">
				<NuxtPicture
					v-if="item.image"
					provider="storyblok"
					:alt="item.title || ''"
					:src="item.image"
					width="60px"
					height="60px"
					loading="lazy"
				/>
			</div>
			<div>
				<h4 class="typo-h5 text-heading-secondary">
					{{ item.title }}
				</h4>

				<span v-if="item.body" class="typo-body-s text-body-tertiary">{{ t('plural.reading', getReadingTime(item.body) ?? 0) }}</span>
				<span v-else-if="item.preparationTime" class="typo-body-s text-body-tertiary">{{ getPreparationTime(item.preparationTime) }} vaření</span>
			</div>
			<AbsoluteInternalLink
				:to="item.fullSlug"
				class="btn btn-secondary btn-sm text-body-secondary whitespace-nowrap"
				@click="setVisibleSearchPopup(false)"
			>
				<NuxtIcon name="custom/arrow-right" aria-hidden="true" class="text-md" filled />
				Číst více
			</AbsoluteInternalLink>
		</div>
	</div>
</template>

<script setup lang="ts">
	import {useStoryblokDatasourcesStore} from '~/stores/storyblokDatasources';
	import {useSearchStore, type StoryblokSearchContent} from '~/stores/search';

	interface Props {
		items: StoryblokSearchContent[]
	}

	defineProps<Props>();

	const store = useStoryblokDatasourcesStore();
	await store.fetchEntries('preparationTime');
	const searchStore = useSearchStore();

	const {t} = useI18n();
	function getReadingTime(data: string) {
		const wordsPerMinute = 200;

		if (!data) { return 0; }
		const wordCount = data.split(/\s+/).length;

		return Math.ceil(wordCount / wordsPerMinute);
	}

	function getPreparationTime(time: string) {
		const filteredEntries = store.preparationTime?.filter((entry) => time.includes(entry.value)).map((entry) => entry.name);
		return filteredEntries ? filteredEntries.shift() : null;
	}

	function setVisibleSearchPopup(state: boolean) {
		searchStore.setVisibleSearchPopup(state);
	}
</script>
